<template>

  <v-app-bar class="px-3"
             color="white"
             flat
             density="compact" v-if="isAuthenticated">
    <v-container class="d-flex align-center justify-sm-space-between header-container">
      <v-btn icon class="me-2" @click.stop="drawer = !drawer">
        <span class="mdi mdi-menu fs-26"></span>
      </v-btn>
      <router-link :to="{name:'delivery.list'}" class="nav-logo-wrap">
        <img class="nav-logo" src="logo.png">
      </router-link>
      <span class="top-menu">

        <template v-if="authUser.type=='owner'">
          <router-link :to="{name:'report.payment.list'}">
            <span class="user-balance d-flex align-center text-center color-green">
              <span class="mdi mdi-currency-usd"></span>
              <span class="user-balance-text">{{Math.ceil(authUser.balance)}} грн.</span>
            </span>
          </router-link>
        </template>
       <span>
          <span class="ms-3 user-name">{{ authUser.name }}</span>
          <span @click="logout" class="mdi mdi-logout ms-1"></span>
       </span>
      </span>


    </v-container>
  </v-app-bar>

  <v-navigation-drawer
      v-model="drawer"
      temporary
      v-if="isAuthenticated"
  >
    <v-list-item
        prepend-icon="mdi mdi-account-badge color-orange fs-22"
        :title="authUser.name"
    ></v-list-item>
    <v-divider></v-divider>

    <v-list density="compact" nav>
      <v-list-item :to="{name:'delivery.list'}" link>
        <template #prepend>
          <span class="mdi mdi-truck fs-22 mr-2"></span>
        </template>
        <template #title><span class="fs-14">Доставки</span></template>
      </v-list-item>
      <template v-if="authUser.type=='owner'">
      <v-list-item :to="{name:'report.payment.list'}" link>
        <template #prepend>
          <span class="mdi mdi-currency-usd fs-22 mr-2"></span>
        </template>
        <template #title><span class="fs-14">Каса</span></template>
      </v-list-item>
      <v-list-item :to="{name:'report.service.car'}" link>
        <template #prepend>
          <span class="mdi mdi-car-wrench fs-22 mr-2"></span>
        </template>
        <template #title><span class="fs-14">Звіт водія</span></template>
      </v-list-item>

      <v-list-item :to="{name:'report.fuel.list'}" link>
        <template #prepend>
          <span class="mdi mdi-gas-station fs-22 mr-2"></span>
        </template>
        <template #title><span class="fs-14">Заправки</span></template>
      </v-list-item>

      <v-list-item v-if="authUser.salary" :to="{name:'report.salary.list'}" link>
        <template #prepend>
          <span class="mdi mdi-wallet-outline fs-22 mr-2"></span>
        </template>
        <template #title><span class="fs-14">Зарплата</span></template>
      </v-list-item>

      <v-list-item href="https://docs.google.com/document/d/1FahjDep3NO53O_b8-3Iqbrs-_YRFoB9I/edit?usp=sharing" target="_blank" rel="noopener noreferrer"  link>
        <template #prepend><span class="mdi mdi-account-badge fs-22 mr-2"></span></template>
        <template #title><span class="fs-14">Стандарт роботи водія</span></template>
      </v-list-item>
      <v-list-item href="https://docs.google.com/document/d/1TgFSzltb74RZIwPKEtxSCP0rkzmQf1xSI_-OzWoa0zg/edit?usp=sharing" target="_blank" rel="noopener noreferrer"  link>
        <template #prepend><span class="mdi mdi-account-badge fs-22 mr-2"></span></template>
        <template #title><span class="fs-14">Діалог з поліцією</span></template>
      </v-list-item>
      <v-list-item href="https://docs.google.com/document/d/11VoDLk4O5yxGdfhfDPrPqAgfQBoBNSTYw7ooGLMikuk/edit?usp=sharing" target="_blank" rel="noopener noreferrer"  link>
        <template #prepend><span class="mdi mdi-account-badge fs-22 mr-2"></span></template>
        <template #title><span class="fs-14">Інструкція по ДТП</span></template>
      </v-list-item>
      <v-list-item href="https://docs.google.com/document/d/1oaBR4INvfwz64Q8UZRH-A6XZOBH1C4pQE4Djy2b1UZg/edit?usp=sharing" target="_blank" rel="noopener noreferrer"  link>
        <template #prepend><span class="mdi mdi-account-badge fs-22 mr-2"></span></template>
        <template #title><span class="fs-14">Форс-мажори</span></template>
      </v-list-item>
      <v-list-item href="https://docs.google.com/document/d/1EaXigIS320ljc8oO6fV2jN0f1uNmH1B5FBn92_KaJxs/edit?usp=sharing" target="_blank" rel="noopener noreferrer"  link>
        <template #prepend><span class="mdi mdi-account-badge fs-22 mr-2"></span></template>
        <template #title><span class="fs-14">Пам'ятка про закріплення вантажу</span></template>
      </v-list-item>

    </template>


    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn block @click="logout">
          Вийти
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>

  <v-container v-if="showServiceAlert">
    <div class="service-alert">
      <span class="mdi mdi-car-wrench"></span>
      <p class="v-alert-title">Нагадування! Будь ласка, заповніть анкету стану авто!</p>
      <router-link
          :to="{name:'report.service.car'}"
          style="text-decoration: none;"
      >
        <v-btn
            color="orange"
            variant="tonal"
        >
          Заповнити анкету
        </v-btn>
      </router-link>
    </div>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";
import store from "@/store";
export default {
  name: "UppMenuCentral",
  computed: {
    ...mapGetters('auth', {
      isAuthenticated: 'isAuthenticated',
      authUser: 'authUser',
      isTypeUser: 'isTypeUser',
      isVerification: 'isVerification'
    }),
    showServiceAlert() {
      if (this.authUser.type!='owner' || !this.isAuthenticated) return false;
      if (!this.authUser.service_report) return true;

      const lastReport = new Date(this.authUser.service_report);
      const now = new Date();
      const diffTime = Math.abs(now - lastReport);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return diffDays >= 7;
    }
  },
  data() {
    return {
      status_location:false,
      drawer:false,
    };
  },
  mounted() {
    if(this.authUser.type=='hired'){
      this.getUserLocation()
    }
  },
  methods: {
    async logout() {
      axios.post('/api/auth/logout').then(r => {
        if (r.status) {
          store.commit('auth/isAuthenticated', false)
          store.commit('auth/authUser', {})
          localStorage.removeItem('X-XSRF-TOKEN')
          this.$router.push({name: 'central.login'})
        }
      })
    },
    async getUserLocation() {
      try {
        const position = await this.getPosition()
        this.updateUserLocation(position.coords.latitude, position.coords.longitude)
        setInterval(async () => {
          const position = await this.getPosition()
          this.updateUserLocation(position.coords.latitude, position.coords.longitude)
        }, 20000)
        this.status_location = true;
      } catch (err) {
        this.status_location = false;
      }
    },
    getPosition() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      })
    },
    updateUserLocation(latitude, longitude) {
      if(this.status_location){
        axios.post('/api/driver/set/location',{ latitude:latitude, longitude:longitude })
      }
    }
  },
}
</script>
